import {sizes} from './sizes';
import {fonts} from './fonts';
import {colors} from './colors';

export const theme = {colors, fonts, sizes};
